// App.js
import React from 'react';
import { Col } from 'react-bootstrap';

import icon1 from '../assets/images/ecommerce.png';
import icon2 from '../assets/images/education.png';
import icon3 from '../assets/images/healthcare-medical.png';
import icon4 from '../assets/images/nutrition.png';
import icon5 from '../assets/images/financials.png';
import icon6 from '../assets/images/steel_manufacturing.png';
import icon7 from '../assets/images/electronics.png';
import icon8 from '../assets/images/fashion.png';
import icon9 from '../assets/images/travel.png';
import icon10 from '../assets/images/life-sciences.png';
import icon11 from '../assets/images/legal.png';
import icon12 from '../assets/images/pets-animalcare.png';
import icon13 from '../assets/images/non-profit.png';
import icon14 from '../assets/images/transportation.png';


const data = [
  {
    id: 1,
    imageUrl: icon1,
    altText: 'Ecommerce',
    title: 'Ecommerce',
    description: "Skyrocket your sales with captivating product stories, seamless UX, and targeted ads. We'll turn browsers into buyers, one click at a time."
  },
  {
    id: 2,
    imageUrl: icon2,
    altText: 'Education',
    title: 'Education',
    description: "Inspire learning through engaging online courses, interactive platforms, and impactful storytelling. We'll bridge the knowledge gap and ignite curiosity."
  },
  {
    id: 3,
    imageUrl:icon3,
    altText: 'Healthcare medical',
    title: 'Healthcare & Medical',
    description: "Build trust and reach patients with empathetic digital strategies. We'll navigate HIPAA regulations and create explicit, accurate content that heals."
  },
  {
    id: 4,
    imageUrl:icon4,
    altText: 'Nutrition',
    title: 'Nutrition',
    description: "Fuel healthy living with science-backed content, targeted social media campaigns, and engaging visuals. We'll turn nutrition goals into delicious realities."
  },
  {
    id: 5,
    imageUrl:icon5,
    altText: 'Financials',
    title: 'Financials',
    description: "Secure trust and attract investors with data-driven strategies, transparent communication, and a user-friendly experience. We'll make finance clear and compelling. "
  },
  {
    id: 6,
    imageUrl:icon6,
    altText: 'Steel Manufacturing',
    title: 'Steel Manufacturing',
    description: "Forge a digital presence that's as strong as your product. We'll showcase your innovation and reach new markets with targeted B2B solutions."
  },
  {
    id: 7,
    imageUrl:icon7,
    altText: 'Electronics',
    title: 'Electronics & CDIT',
    description: "Power up your brand with cutting-edge tech content, interactive demos, and community engagement. We'll spark excitement and drive demand for your gadgets."
  },
  {
    id: 8,
    imageUrl:icon8,
    altText: 'Fashion',
    title: 'Fashion & Lifestyle',
    description:"Elevate your brand with aspirational storytelling, stunning visuals, and influencer partnerships. We'll set trends and make your style irresistible."
  },
  {
    id: 9,
    imageUrl:icon9,
    altText: 'Travel',
    title: 'Travel & Hospitality',
    description: "Unforgettable journeys start with unforgettable digital experiences. We'll craft immersive content, targeted ads, and social media strategies that ignite wanderl "
  },
  {
    id: 10,
    imageUrl:icon10,
    altText: 'Life Sciences',
    title: 'Life Sciences',
    description: "Advance discovery with clear, impactful communication. We'll translate complex science into engaging content for researchers, investors, and the public."
  },
  {
    id: 11,
    imageUrl:icon11,
    altText: 'Legal',
    title: 'Legal',
    description: "Navigate the digital landscape with confidence. We'll build a reliable online presence, attract new clients, and showcase your expertise with authority."
  },
  {
    id: 12,
    imageUrl:icon12,
    altText: 'Pets Animalcare',
    title: 'Pets Animalcare',
    description: "Unleash the power of pawsitive marketing! We'll connect you with passionate pet owners through adorable content, targeted campaigns, and interactive platforms."
  },
  {
    id: 13,
    imageUrl:icon13,
    altText: 'Non Profit',
    title: 'Non-Profit & Charity',
    description: "Inspire action and amplify your mission with compelling storytelling, social media engagement, and strategic fundraising campaigns. We'll make a difference together."
  },
  {
    id: 14,
    imageUrl:icon14,
    altText: 'Transportation',
    title: 'Transportation & Logistics',
    description: "Deliver efficient journeys with data-driven solutions, dynamic route planning, and seamless online experiences. We'll keep your wheels turning and customers satisfied"
  }
];

const DynamicContentComponent = ({ item }) => {

  return (
    <div className="building_brands education">

      <img src={item.imageUrl} alt={item.altText} />
      <h3 class="ecommerce_text"> {item.title}</h3>
      <p>{item.description}</p>
    </div>
  );
}

const IndustriesData = () => {
  return (
    <>         
        
            {data.map(item => (
            <Col lg={3}>
                <DynamicContentComponent key={item.id} item={item} />
            </Col>
     
        
      ))}
    </>
  );
}

export default IndustriesData;
